/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AgendarEnArea as AgendarEnArea,
  rec_CeldaCalendario as CeldaCalendario,
  rec_Componente_DO_68_79 as Componente_DO_68_79,
  rec_DetalleTarea as DetalleTarea,
  rec_Er as Er,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_Mr as Mr,
  rec_NuevaReunion as NuevaReunion,
  rec_Qa as Qa,
  rec_Qx as Qx,
  rec_React as React,
  rec_Rr as Rr,
  rec_SO as SO,
  rec_SelectorMultiple as SelectorMultiple,
  rec_Sn as Sn,
  rec_TarjetaTarea as TarjetaTarea,
  rec_Yx as Yx,
  rec__O as _O,
  rec_api as api,
  rec_bO as bO,
  rec_bS as bS,
  rec_gO as gO,
  rec_hO as hO,
  rec_ii as ii,
  rec_jr as jr,
  rec_mS as mS,
  rec_nw as nw,
  rec_pS as pS,
  rec_tw as tw,
  rec_vO as vO,
  rec_vS as vS,
  rec_yO as yO,
  rec_yS as yS,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function Calendario() {
  let [e, t] = (0, React.useState)(() => new Date()),
    [n, r] = (0, React.useState)([]),
    [i, a] = (0, React.useState)(!0),
    [o, s] = (0, React.useState)(``),
    [c, l] = (0, React.useState)(null),
    [u, f] = (0, React.useState)(null),
    [p, m] = (0, React.useState)({
      unidades: [],
      proyectos: [],
    }),
    [h, g] = (0, React.useState)(!1),
    [_, v] = (0, React.useState)(null),
    [y, b] = (0, React.useState)(null),
    [x, S] = (0, React.useState)(null),
    [C, w] = (0, React.useState)(null),
    [T, E] = (0, React.useState)(() => tw(`vista-calendario`, `calendario`));
  function D(e) {
    (E(e), nw(`vista-calendario`, e));
  }
  let [O, k] = (0, React.useState)(() => tw(`filtro-calendario`, `pendientes`));
  function A(e) {
    let t = e || `pendientes`;
    (k(t), nw(`filtro-calendario`, t));
  }
  let j = (0, React.useMemo)(
      () => new Date(e.getFullYear(), e.getMonth(), 1),
      [e],
    ),
    M = (0, React.useMemo)(
      () => new Date(e.getFullYear(), e.getMonth() + 1, 1),
      [e],
    ),
    N = (0, React.useMemo)(() => vS(j), [j]),
    P = (0, React.useMemo)(() => {
      let e = new Date(N);
      return (e.setDate(e.getDate() + 42), e);
    }, [N]),
    F = (0, React.useCallback)(async () => {
      (a(!0), s(``));
      try {
        r(await api(`/calendario?desde=${hO(N)}&hasta=${hO(P)}`));
      } catch (e) {
        s(e.message);
      } finally {
        a(!1);
      }
    }, [N, P]);
  ((0, React.useEffect)(() => {
    F();
  }, [F]),
    (0, React.useEffect)(() => {
      api(`/mis-areas`)
        .then((e) =>
          m({
            unidades: e?.unidades ?? [],
            proyectos: e?.proyectos ?? [],
          }),
        )
        .catch(() => {});
    }, []));
  async function I() {
    try {
      let e = await Qa(`/calendario/ical?desde=${hO(j)}&hasta=${hO(M)}`),
        t = document.createElement(`a`);
      ((t.href = e),
        (t.download = `gth-planner.ics`),
        t.click(),
        setTimeout(() => URL.revokeObjectURL(e), 4e3));
    } catch (e) {
      s(e.message);
    }
  }
  let L = (0, React.useMemo)(() => {
      let e = bO.find((e) => e.value === O)?.estados ?? null,
        t = {};
      for (let r of n) {
        if (e && r.tipo === `TAREA` && r.estado && !e.includes(r.estado))
          continue;
        let n = r.fecha.slice(0, 10);
        (t[n] ||= []).push(r);
      }
      return t;
    }, [n, O]),
    R = (0, React.useMemo)(() => {
      let t = [],
        n = new Date(N),
        r = hO(new Date());
      for (let i = 0; i < 42; i++) {
        let i = hO(n);
        (t.push({
          fecha: new Date(n),
          clave: i,
          enMes: n.getMonth() === e.getMonth(),
          esHoy: i === r,
          eventos: L[i] || [],
        }),
          n.setDate(n.getDate() + 1));
      }
      return t;
    }, [N, e, L]),
    z = (0, React.useMemo)(() => {
      let e = [];
      for (let t = 0; t < R.length; t += 7) {
        let n = R.slice(t, t + 7).filter(
          (e) => e.enMes && e.eventos.length > 0,
        );
        if (n.length === 0) continue;
        let r = n[0].fecha,
          i = n[n.length - 1].fecha;
        e.push({
          clave: `s${t}`,
          titulo: `Semana ${yS(r)} · ${r.getDate()} al ${i.getDate()} de ${i.toLocaleDateString(
            `es-PE`,
            {
              month: `long`,
            },
          )}`,
          dias: n,
        });
      }
      return e;
    }, [R]);
  return (
    <EstructuraPrincipal
      title={`Calendario`}
      children={[
        <div
          className={`flex flex-col gap-4`}
          children={[
            <div
              className={`flex flex-wrap items-center gap-2 sm:gap-3`}
              children={[
                <button
                  type={`button`}
                  onClick={() =>
                    t(new Date(e.getFullYear(), e.getMonth() - 1, 1))
                  }
                  className={`rounded-lg border border-(--border) p-2 hover:bg-(--accent-bg)`}
                  aria-label={`Mes anterior`}
                  children={(0, JSXRuntime.jsx)(jr, {
                    className: `h-4 w-4`,
                  })}
                />,
                <span
                  className={`min-w-32 text-center text-sm font-medium capitalize text-(--text-h) sm:min-w-40`}
                  children={e.toLocaleDateString(`es-PE`, {
                    month: `long`,
                    year: `numeric`,
                  })}
                />,
                <button
                  type={`button`}
                  onClick={() =>
                    t(new Date(e.getFullYear(), e.getMonth() + 1, 1))
                  }
                  className={`rounded-lg border border-(--border) p-2 hover:bg-(--accent-bg)`}
                  aria-label={`Mes siguiente`}
                  children={<Mr className={`h-4 w-4`} />}
                />,
                <button
                  type={`button`}
                  onClick={() => t(new Date())}
                  className={zo}
                  children={`Hoy`}
                />,
                i &&
                  (0, JSXRuntime.jsx)(ii, {
                    className: `h-4 w-4 animate-spin text-(--text)`,
                  }),
                <div
                  className={`w-40 sm:hidden`}
                  children={
                    <SelectorMultiple value={T} onChange={D} opciones={yO} />
                  }
                />,
                <div
                  className={`w-44`}
                  children={
                    <SelectorMultiple
                      value={O}
                      onChange={A}
                      opciones={bO}
                      placeholder={`Lo que falta`}
                    />
                  }
                />,
                p.unidades.length > 0 && (
                  <button
                    type={`button`}
                    onClick={() => g(!0)}
                    aria-label={`Nueva reunión`}
                    className={`ml-auto rounded-full border border-(--border) p-2 text-(--text-h) transition hover:bg-(--accent-bg) sm:px-4 sm:py-2 sm:text-sm`}
                    children={[
                      <Er
                        className={`inline h-4 w-4 sm:mr-1 sm:h-3.5 sm:w-3.5`}
                      />,
                      <span
                        className={`hidden sm:inline`}
                        children={`Nueva reunión`}
                      />,
                    ]}
                  />
                ),
                <button
                  type={`button`}
                  onClick={I}
                  aria-label={`Descargar .ics`}
                  className={`rounded-full border border-(--border) p-2 text-(--text-h) transition hover:bg-(--accent-bg) sm:px-4 sm:py-2 sm:text-sm ${p.unidades.length > 0 ? `` : `ml-auto`}`}
                  children={[
                    <Rr
                      className={`inline h-4 w-4 sm:mr-1 sm:h-3.5 sm:w-3.5`}
                    />,
                    <span
                      className={`hidden sm:inline`}
                      children={`Descargar .ics`}
                    />,
                  ]}
                />,
              ]}
            />,
            <EstadoError mensaje={o} onReintentar={F} />,
            T === `calendario` && (
              <div
                className={`animar-entrada grid grid-cols-7 gap-1 sm:hidden`}
                children={[
                  gO.map((e) => (
                    <div
                      key={e}
                      className={`pb-1 text-center text-[10px] uppercase tracking-wide text-(--text)`}
                      children={e[0]}
                    />
                  )),
                  R.map((e) => (
                    <button
                      key={e.clave}
                      type={`button`}
                      onClick={() => e.eventos.length > 0 && l(e)}
                      aria-label={`${e.fecha.getDate()}${e.eventos.length ? `, ${e.eventos.length} cosas` : `, sin nada`}`}
                      className={`flex aspect-square flex-col items-center justify-center rounded-xl text-sm transition ${e.enMes ? `` : `opacity-30`} ${e.esHoy ? `bg-(--accent) font-medium text-(--accent-fg)` : `text-(--text-h)`} ${e.eventos.length > 0 && !e.esHoy ? `bg-(--accent-bg)` : ``} ${e.eventos.length > 0 ? `active:opacity-70` : ``}`}
                      children={[
                        e.fecha.getDate(),
                        e.eventos.length > 0 && (
                          <span
                            className={`mt-0.5 h-1.5 w-1.5 rounded-full ${e.esHoy ? `bg-(--accent-fg)` : `bg-(--accent)`}`}
                          />
                        ),
                      ]}
                    />
                  )),
                ]}
              />
            ),
            T === `agenda` && (
              <div
                className={`animar-entrada flex flex-col gap-2 sm:hidden`}
                children={
                  R.filter((e) => e.enMes && e.eventos.length > 0).length ===
                  0 ? (
                    <p
                      className={`rounded-xl border border-dashed border-(--border) px-3 py-6 text-center text-sm text-(--text)`}
                      children={`No hay nada agendado este mes.`}
                    />
                  ) : (
                    R.filter((e) => e.enMes && e.eventos.length > 0).map(
                      (e) => (
                        <button
                          key={e.clave}
                          type={`button`}
                          onClick={() => l(e)}
                          className={`flex w-full gap-3 rounded-xl border px-3 py-2 text-left transition active:bg-(--accent-bg) ${e.esHoy ? `border-(--accent) bg-(--accent-bg)` : `border-(--border)`}`}
                          children={[
                            <div
                              className={`flex w-10 shrink-0 flex-col items-center`}
                              children={[
                                <span
                                  className={`text-lg font-medium ${e.esHoy ? `text-(--accent)` : `text-(--text-h)`}`}
                                  children={e.fecha.getDate()}
                                />,
                                <span
                                  className={`text-[10px] uppercase text-(--text)`}
                                  children={e.fecha
                                    .toLocaleDateString(`es-PE`, {
                                      weekday: `short`,
                                    })
                                    .replace(`.`, ``)}
                                />,
                              ]}
                            />,
                            <div
                              className={`flex min-w-0 flex-1 flex-col gap-1`}
                              children={e.eventos.map((e) => (
                                <span
                                  key={`${e.tipo}-${e.id}`}
                                  className={`flex items-center gap-1.5 text-sm text-(--text-h)`}
                                  children={[
                                    <span
                                      className={`h-2 w-2 shrink-0 rounded-full`}
                                      style={{
                                        background: SO(e),
                                      }}
                                    />,
                                    <span
                                      className={`truncate`}
                                      children={e.titulo}
                                    />,
                                  ]}
                                />
                              ))}
                            />,
                          ]}
                        />
                      ),
                    )
                  )
                }
              />
            ),
            T === `semanas` && (
              <div
                className={`animar-entrada flex flex-col gap-3 sm:hidden`}
                children={
                  z.length === 0 ? (
                    <p
                      className={`rounded-xl border border-dashed border-(--border) px-3 py-6 text-center text-sm text-(--text)`}
                      children={`No hay nada agendado este mes.`}
                    />
                  ) : (
                    z.map((e) => (
                      <section
                        key={e.clave}
                        className={`flex flex-col gap-1.5`}
                        children={[
                          <p
                            className={`text-xs font-medium uppercase tracking-wide text-(--text)`}
                            children={e.titulo}
                          />,
                          e.dias.map((e) => (
                            <button
                              key={e.clave}
                              type={`button`}
                              onClick={() => l(e)}
                              className={`flex w-full items-baseline gap-2 rounded-xl border border-(--border) px-3 py-2 text-left text-sm transition active:bg-(--accent-bg)`}
                              children={[
                                <span
                                  className={`w-16 shrink-0 text-xs text-(--text)`}
                                  children={e.fecha
                                    .toLocaleDateString(`es-PE`, {
                                      weekday: `short`,
                                      day: `numeric`,
                                    })
                                    .replace(`.`, ``)}
                                />,
                                <span
                                  className={`min-w-0 flex-1 truncate text-(--text-h)`}
                                  children={e.eventos
                                    .map((e) => e.titulo)
                                    .join(` · `)}
                                />,
                                <span
                                  className={`shrink-0 text-xs text-(--text)`}
                                  children={e.eventos.length}
                                />,
                              ]}
                            />
                          )),
                        ]}
                      />
                    ))
                  )
                }
              />
            ),
            _ && (
              <CeldaCalendario
                celda={R.find((e) => e.clave === _)}
                puedeCrear={p.unidades.length > 0 && bS(_)}
                onVer={l}
                onCrear={() => b(_)}
                onCerrar={() => v(null)}
              />
            ),
            <div
              className={`animar-entrada hidden overflow-x-auto sm:block`}
              children={
                <div
                  className={`min-w-[756px] overflow-hidden rounded-2xl border border-(--border) bg-(--border)`}
                  children={[
                    <div
                      className={`grid ${vO} gap-px`}
                      children={[
                        <div
                          className={`bg-(--panel) py-2 text-center text-[10px] font-medium uppercase tracking-wide text-(--text)/60`}
                          title={`Número de semana`}
                          children={`sem`}
                        />,
                        gO.map((e) => (
                          <div
                            key={e}
                            className={`bg-(--panel) py-2 text-center text-xs font-medium uppercase tracking-wide text-(--text)`}
                            children={e}
                          />
                        )),
                      ]}
                    />,
                    <div
                      className={`grid ${vO} gap-px`}
                      children={R.map((e, t) => {
                        let n = e.eventos.slice(0, _O),
                          r = e.eventos.length - n.length,
                          i = e.clave === _;
                        return (
                          <React.Fragment
                            key={e.clave}
                            children={[
                              t % 7 == 0 && (
                                <button
                                  type={`button`}
                                  onClick={() => w(R.slice(t, t + 7))}
                                  aria-label={`Ver la semana ${yS(e.fecha)}`}
                                  className={`flex flex-col items-center justify-center gap-0.5 bg-(--accent-bg) text-[11px] tabular-nums text-(--accent-texto) transition hover:brightness-95`}
                                  children={[
                                    <span
                                      className={`text-[9px] uppercase opacity-70`}
                                      children={`sem`}
                                    />,
                                    <span
                                      className={`font-medium`}
                                      children={yS(e.fecha)}
                                    />,
                                  ]}
                                />
                              ),
                              <button
                                type={`button`}
                                onClick={() => v(e.clave)}
                                onDoubleClick={() => bS(e.clave) && b(e.clave)}
                                aria-pressed={i}
                                aria-label={`${e.fecha.toLocaleDateString(
                                  `es-PE`,
                                  {
                                    day: `numeric`,
                                    month: `long`,
                                  },
                                )}, ${e.eventos.length === 0 ? `sin nada` : e.eventos.length === 1 ? `1 cosa` : `${e.eventos.length} cosas`}`}
                                className={`flex min-h-28 cursor-pointer flex-col items-stretch gap-1 p-1.5 text-left transition ${e.enMes ? `opacity-100` : `opacity-40`} ${i ? `bg-(--accent-bg) ring-2 ring-inset ring-(--accent)` : `bg-(--bg) hover:bg-(--accent-bg)`}`}
                                children={[
                                  <span
                                    className={`self-end rounded-full px-1.5 text-xs ${e.esHoy ? `bg-(--accent) font-medium text-(--accent-fg)` : `text-(--text)`}`}
                                    children={e.fecha.getDate()}
                                  />,
                                  <div
                                    className={`flex flex-1 flex-col gap-0.5`}
                                    children={[
                                      n.map((e) => (
                                        <span
                                          key={`${e.tipo}-${e.id}`}
                                          className={`flex items-center gap-1 truncate rounded px-1 py-0.5 text-[11px] text-(--text-h)`}
                                          style={{
                                            background: `var(--panel)`,
                                          }}
                                          children={[
                                            <span
                                              className={`h-1.5 w-1.5 shrink-0 rounded-full`}
                                              style={{
                                                background: SO(e),
                                              }}
                                            />,
                                            <span
                                              className={`truncate`}
                                              children={e.titulo}
                                            />,
                                          ]}
                                        />
                                      )),
                                      r > 0 && (
                                        <span
                                          className={`px-1 text-[11px] text-(--text)`}
                                          children={[`+`, r, ` más`]}
                                        />
                                      ),
                                    ]}
                                  />,
                                ]}
                              />,
                            ]}
                          />
                        );
                      })}
                    />,
                  ]}
                />
              }
            />,
          ]}
        />,
        c && (
          <Modal
            titulo={c.fecha.toLocaleDateString(`es-PE`, {
              weekday: `long`,
              day: `numeric`,
              month: `long`,
            })}
            onClose={() => l(null)}
            children={
              <ul
                className={`flex flex-col gap-2`}
                children={c.eventos.map((e) => (
                  <li
                    key={`${e.tipo}-${e.id}`}
                    className={`flex items-center gap-2 rounded-xl border border-(--border) p-2 text-sm`}
                    children={[
                      <span
                        className={`h-2.5 w-2.5 shrink-0 rounded-full`}
                        style={{
                          background: SO(e),
                        }}
                      />,
                      <span
                        className={`rounded bg-(--panel) px-1.5 py-0.5 text-[11px] uppercase text-(--text)`}
                        children={e.tipo}
                      />,
                      e.tipo === `TAREA` ? (
                        <button
                          type={`button`}
                          onClick={() => {
                            (f(e.id), l(null));
                          }}
                          className={`min-w-0 flex-1 truncate text-left text-(--text-h) hover:text-(--accent) hover:underline`}
                          children={e.titulo}
                        />
                      ) : (
                        <Sn
                          to={mS(e)}
                          onClick={() => l(null)}
                          className={`min-w-0 flex-1 truncate text-(--text-h) hover:underline`}
                          children={e.titulo}
                        />
                      ),
                      e.tipo === `TAREA` && e.estado && (
                        <span
                          className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] ${Qx(e.estado)}`}
                          children={Yx(e.estado)}
                        />
                      ),
                      e.tipo === `REUNION` && (
                        <span
                          className={`shrink-0 text-xs text-(--text)`}
                          children={pS(e.fecha)?.split(` `).slice(-1)}
                        />
                      ),
                    ]}
                  />
                ))}
              />
            }
          />
        ),
        u && <TarjetaTarea tareaId={u} onClose={() => f(null)} onCambio={F} />,
        h && (
          <NuevaReunion
            areasPosibles={p.unidades}
            proyectosPosibles={p.proyectos}
            fechaInicial={typeof h == `string` ? `${h}T09:00` : ``}
            onClose={() => g(!1)}
            onGuardado={F}
          />
        ),
        C && (
          <Componente_DO_68_79
            dias={C}
            onCerrar={() => w(null)}
            onDia={(e) => {
              (w(null), l(e));
            }}
          />
        ),
        y && (
          <AgendarEnArea
            fecha={y}
            unidades={p.unidades}
            onCerrar={() => b(null)}
            onReunion={() => {
              let e = y;
              (b(null), g(e));
            }}
            onTarea={(e) => {
              (b(null),
                S({
                  fecha: y,
                  unidad: e,
                }));
            }}
          />
        ),
        x && (
          <DetalleTarea
            proyecto={{
              id: null,
              unidadId: x.unidad.id,
              nombre: x.unidad.nombre,
              miRol: `COLABORADOR`,
              miembros: [],
            }}
            preset={{
              fechaVencimiento: x.fecha,
            }}
            onClose={() => S(null)}
            onGuardado={() => {
              (S(null), F());
            }}
          />
        ),
      ]}
    />
  );
}
